import { useUserStore } from '@/store'

export default {
  methods: {
    accessAllowed(option) {
      const userStore = useUserStore()

      if (option.requires_subscription && !userStore.isSubscriber) return false

      if (
        option.requires_pro_subscription &&
        !userStore.isEnterpriseSubscriber &&
        !userStore.isProSubscriber
      )
        return false

      return true
    }
  }
}
